// Dans: providers/QueryProvider.tsx
"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

// On ne crée l'instance du client qu'une seule fois pour éviter les re-renders inutiles.
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Configuration par défaut pour toutes les requêtes de l'application
            staleTime: 1000 * 60 * 5, // Les données sont considérées "fraîches" pendant 5 minutes
            refetchOnWindowFocus: false, // Optionnel: désactive le rafraîchissement automatique au focus de la fenêtre
        },
    },
});

export function QueryProvider({ children }: { children: React.ReactNode }) {
    return (
        // Le provider met le client à disposition de tous les composants enfants
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}